
import { _config } from './webConfig'

let urlSetting = {
  prefix: '/api',
  domain: _config.DevDomain
}
// console.log('get process env node_env ',process.env.NODE_ENV, _config.ApiDomain)
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code 生产环境
  urlSetting.domain = _config.DevDomain
} else {
  // prod code 发布环境
  urlSetting.domain = _config.ApiDomain //'http://39.106.28.86:9183'
}

const urlPrefix = `${urlSetting.domain}${urlSetting.prefix}`
const PostValidate = `${urlPrefix}/validate?h_np=1`

export {
  urlSetting,
  urlPrefix,
  PostValidate
}